import React from 'react'
import classNames from 'classnames'

import Staff from './Staff'
import Board from './Board'

class TabsTeam extends React.Component {
  state = {
    tab: 'tabA',
  }

  render() {
    const { tab } = this.state
    const classA = classNames({ 'is-active': tab === 'tabA' })
    const classB = classNames({ 'is-active': tab === 'tabB' })

    return (
      <section
        className="section is-large bg-gradient"
        style={{ paddingBottom: '0' }}
      >
        <div className="container content u-paddingsides-mobile">
          <div className="has-text-centered-tablet">
            <h2 className="title">Meet Our Team</h2>
            <p className="subtitle">Great teams are made from great people.</p>
          </div>
          <div className="tabs is-centered is-large team-tab team-tab">
            <ul>
              <li className={classA}>
                <button id="tabA" onClick={this.toggleTab}>
                  Leadership Team
                </button>
              </li>
              <li className={classB}>
                <button id="tabB" onClick={this.toggleTab}>
                  Board &amp; Advisors
                </button>
              </li>
            </ul>
          </div>

          {tab === 'tabA' ? <Staff /> : <Board />}
        </div>
      </section>
    )
  }

  toggleTab = e => {
    e.preventDefault()
    if (this.state.tab !== e.currentTarget.id) {
      this.setState({
        tab: e.currentTarget.id,
      })
    }
  }
}

export default TabsTeam
